import { render, staticRenderFns } from "./UploadImage.v2.vue?vue&type=template&id=4ba035da&scoped=true&"
import script from "./UploadImage.v2.vue?vue&type=script&lang=js&"
export * from "./UploadImage.v2.vue?vue&type=script&lang=js&"
import style0 from "./UploadImage.v2.vue?vue&type=style&index=0&id=4ba035da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba035da",
  null
  
)

export default component.exports